import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AccountHorseShowEntriesView} from '../models/account_horse_show_entries_view';
import {AppSettings} from '../app.settings';
import {AccountHorseShowEntriesViewList} from '../models/account_horse_show_entries_view_list';

@Injectable({
  providedIn: 'root'
})
export class AccountHorseShowEntryViewService {

  constructor(public http: HttpClient) {
  }

  public getHorseShowEntryViewList(is_submitted: boolean, pageSize: number, offset:number): Promise<AccountHorseShowEntriesViewList> {
    return this.getHorseShowEntryViews(`user-horse-show-entries/${is_submitted}/${pageSize}/${offset}`);
  }

  private getHorseShowEntryViews(endPointAndParameters:string): Promise<AccountHorseShowEntriesViewList> {
    return new Promise((resolve, reject) => {

      console.log(AppSettings.NEW_API_ENDPOINT + endPointAndParameters);

      return    this.http.get(AppSettings.NEW_API_ENDPOINT + endPointAndParameters).subscribe({
        next: (response: any) => {
          if(response.data && response.data.type == 'AccountHorseShowAndEntriesViewList'){
            resolve(response.data.attributes);
          }
        },
        error: (e) => reject(e),
        complete: () => console.info('call to retrieve entry view list complete')
      });

    });
  }

}
